import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';

export const GridFlexColumnStyled = styled(Grid, {
  name: 'GridFlexColumnStyled',
})(() => ({
  display: 'flex',
  flexDirection: 'column',
}));
